// Get the current script element
const scriptElement =
  document.currentScript ||
  (() => {
    const scripts = document.getElementsByTagName("script");
    return scripts[scripts.length - 1];
  })();

// Get the script's source URL
const scriptSrc = (scriptElement as any).src;

// Create a URL object to easily extract the domain
const scriptURL = new URL(scriptSrc);

// Extract the domain name
export const HOST_DOMAIN = `https://${scriptURL.hostname}`;
/**
 * The APPID is the domain name without the protocol.
 * For example, if the HOST_DOMAIN is "https://example.com",
 * the APPID will be "example.com".
 */
export const APPID = HOST_DOMAIN.split("https://")[1];
